import gsap from 'gsap'

export const initCursor = () => {
	gsap.set('.cursor', { xPercent: -5, yPercent: -5 })
	const cursor = document.querySelector('.cursor')
	const position = { x: window.innerWidth / 2, y: window.innerHeight / 2 }
	const mouse = { x: position.x, y: position.y }

	window.addEventListener('mousemove', (e) => {
		mouse.x = e.x
		mouse.y = e.y
		gsap.to(cursor, { duration: 0.35, x: mouse.x, y: mouse.y })
	})

	document.addEventListener('mousedown', () => {
		if (cursor.classList.contains('visible')) {
			cursor.classList.add('shrink')
		}
	})

	document.addEventListener('mouseup', () => {
		cursor.classList.remove('shrink')
	})
}

export const resetCursor = () => {
	const cursor = document.querySelector('.cursor')
	if (cursor) cursor.className = 'cursor'
}

let isTransitioning = false
export const setCursorTransitioning = (value) => {
	isTransitioning = value
	if (value) resetCursor()
}

export const initCursorEvents = () => {
	const cursor = document.querySelector('.cursor')
	const items = document.querySelectorAll('[data-cursor]')

	items.forEach(item => {
		const type = 'cursor-' + item.dataset.cursor
		item.addEventListener('mouseenter', () => {
			if (isTransitioning) return
			cursor.classList.add(type)
			cursor.classList.add('visible')
		})
		item.addEventListener('mouseleave', () => {
			cursor.classList.remove(type)
			cursor.classList.remove('visible')
		})
	})
}

export default () => { }